"use strict";
/**
 * @module "ethpm/config"
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connector = void 0;
const ThrowReporter_1 = require("io-ts/lib/ThrowReporter");
class Connector {
    connect(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const validation = this.optionsType.decode(options);
            if (!validation.isRight()) {
                ThrowReporter_1.ThrowReporter.report(validation);
            }
            return this.init(validation.value);
        });
    }
}
exports.Connector = Connector;
